module.exports = __webpack_public_path__ + "img/20200613_094923.c04cdd2f.jpg";